import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { GlobalStyles } from './GlobalStyles';
import './config/axios'; // Global axios defaults (withCredentials for HttpOnly cookies)
import './styles/global.scss';
import './styles/pagination-mobile-override.css'; // Additional mobile pagination fix
import './styles/modalResponsive.css'; // Modal positioning for sidebar
import { getTheme } from './theme';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';
import { StoreProvider } from './hooks/storeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './hooks/useInstallPrompt'; // Capture the PWA install prompt at startup

// Import the router configuration
import { ROUTER_CONFIG } from './constants/routerConfig';

// Providers
import { ConfigProvider } from 'antd';

const router = createBrowserRouter(ROUTER_CONFIG);
const themeObject = getTheme();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary>
    <StoreProvider>
      <NotificationProvider>
        <ConfigProvider theme={themeObject}>
          <ThemeProvider theme={theme}>
            <RouterProvider router={router} />
            <GlobalStyles />
          </ThemeProvider>
        </ConfigProvider>
      </NotificationProvider>
    </StoreProvider>
  </ErrorBoundary>
);

// Register the service worker so the app is installable and works offline.
serviceWorkerRegistration.register();
